import { graphqlRequest } from "../graphqlClient";
import type {
  Forecast12MonthBalanceViewConnection,
  Forecast12MonthBalanceViewFilterInput,
} from "../models/forecast12MonthBalanceView";

export interface Forecast12MonthBalanceViewSortInput {
  field: string;
  order: "Ascending" | "Descending";
}

interface Forecast12MonthBalanceViewListResponse {
  transactions: {
    forecast12MonthBalanceViewList: Forecast12MonthBalanceViewConnection;
  };
}

export async function getForecast12MonthBalancesGraphql(
  filter?: Forecast12MonthBalanceViewFilterInput,
  first?: number,
  after?: string,
  sort?: Forecast12MonthBalanceViewSortInput[],
): Promise<Forecast12MonthBalanceViewConnection> {
  const query = `
    query Forecast12MonthBalanceViewList($filter: Forecast12MonthBalanceViewFilterInput, $first: Int, $after: String, $sort: [Forecast12MonthBalanceViewSortSortByInput!]) {
      transactions {
        forecast12MonthBalanceViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              monthKey
              date
              openingBalance
              closingBalance
              incoming
              outgoing
              netChange
              confidenceScore
              contributingLayers
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
  const data = await graphqlRequest<Forecast12MonthBalanceViewListResponse>(
    query,
    {
      filter,
      first,
      after,
      sort,
    },
  );
  return data.transactions.forecast12MonthBalanceViewList;
}

interface Forecast12MonthBalanceViewCountResponse {
  transactions: {
    forecast12MonthBalanceViewCount: number;
  };
}

export async function getForecast12MonthBalancesCount(
  filter?: Forecast12MonthBalanceViewFilterInput,
): Promise<number> {
  const query = `
    query Forecast12MonthBalanceViewCount($filter: Forecast12MonthBalanceViewFilterInput) {
      transactions {
        forecast12MonthBalanceViewCount(filter: $filter)
      }
    }
  `;
  const data = await graphqlRequest<Forecast12MonthBalanceViewCountResponse>(
    query,
    {
      filter,
    },
  );
  return data.transactions.forecast12MonthBalanceViewCount;
}

interface Forecast12MonthBalanceViewDistinctValuesResponse {
  transactions: {
    forecast12MonthBalanceViewDistinctValues: string[];
  };
}

export async function getForecast12MonthBalanceDistinctValues(
  field: string,
): Promise<string[]> {
  const query = `
    query Forecast12MonthBalanceViewDistinctValues($field: String!) {
      transactions {
        forecast12MonthBalanceViewDistinctValues(field: $field)
      }
    }
  `;
  const data =
    await graphqlRequest<Forecast12MonthBalanceViewDistinctValuesResponse>(
      query,
      {
        field,
      },
    );
  return data.transactions.forecast12MonthBalanceViewDistinctValues;
}
